import { TabsBase } from "./app.tabs-base.js";

var mobile_nav_tabs_default = (() => {
    if (customElements.get("mobile-nav-tabs")) return;
    customElements.define("mobile-nav-tabs", class MobileNavTabs extends TabsBase {
        defaultTab=null;
        connectedCallback() {
            super.connectedCallback();
            const rootTabs = Array.from(this.querySelectorAll('[role="tab"]')).filter(tab => !tab.closest('[role="tabpanel"]'));
            this.defaultTab = rootTabs.find(tab => tab.getAttribute("aria-selected") === "true") || rootTabs[0] || null;
        }
        activateTab(tab) {
            const tabs = this.getTabsFor(tab);
            if (tabs.length === 0) return;
            tabs.forEach(current => {
                const selected = current === tab;
                current.setAttribute("aria-selected", selected ? "true" : "false");
                current.setAttribute("tabindex", selected ? "0" : "-1");
                const panelId = current.getAttribute("aria-controls");
                const panel = panelId ? this.getPanel(panelId) : null;
                if (!panel) return;
                if (selected) panel.removeAttribute("hidden"); else {
                    panel.setAttribute("hidden", "");
                    this.resetSubTabs(panel);
                }
            });
        }
        resetSubTabs(container) {
            container.querySelectorAll('[role="tablist"]').forEach(subTablist => {
                const firstTab = subTablist.querySelector('[role="tab"]');
                if (firstTab) this.activateTab(firstTab);
            });
        }
        reset() {
            Array.from(this.querySelectorAll('[role="tablist"]')).filter(tablist => !tablist.closest('[role="tabpanel"]')).forEach(tablist => {
                const targetTab = this.defaultTab && tablist.contains(this.defaultTab) ? this.defaultTab : tablist.querySelector('[role="tab"]');
                if (!targetTab) return;
                this.activateTab(targetTab);
                const panelId = targetTab.getAttribute("aria-controls");
                if (panelId) {
                    const panel = this.getPanel(panelId);
                    if (panel) this.resetSubTabs(panel);
                }
            });
            this.querySelectorAll('[role="tablist"]').forEach(tablist => {
                tablist.scrollLeft = 0;
            });
        }
    });
})();